import Auth from 'j-toker';
import * as types from './types';
import { apiGet, apiPost, apiPut, apiDelete } from 'helpers/ApiHelper';
import { showFailure, showSuccess } from 'actions/notificationActions';
import { toFriendlyDateString } from 'helpers/Formatter';

const makeUrl = path => Auth.getApiUrl() + '/landlords/payment_processing' + path;

export const storeBatch = batch => {
  return {
    type: types.STORE_BATCH,
    payload: batch,
  };
};

const storeBatches = (batches, searchResultCount, offset) => {
  return {
    type: types.STORE_BATCHES,
    payload: {
      batches,
      searchResultCount,
      offset,
    },
  };
};

const storeBatchStats = stats => {
  return {
    type: types.STORE_BATCH_STATS,
    payload: { stats },
  };
};

const storeBatchPayments = (batchPayments, searchResultCount, offset) => {
  return {
    type: types.STORE_BATCH_PAYMENTS,
    payload: {
      batchPayments,
      searchResultCount,
      offset,
    },
  };
};

export function getBatch(batchId) {
  return dispatch => {
    return dispatch({
      type: types.FETCH_BATCH,
      payload: apiGet(makeUrl(`/batches/${batchId}`))
        .done(response => {
          dispatch(storeBatch(response.batch));
        })
        .catch(error => {
          dispatch(showFailure(error));
        }),
    });
  };
}

export function getFilteredBatches(subset = 'all', offset = 0, options = {}) {
  return dispatch => {
    return dispatch({
      type: types.FETCH_BATCHES,
      payload: apiPost(makeUrl(`/filtered_batches?subset=${subset}&offset=${offset}`), options)
        .done(response => {
          dispatch(storeBatches(response.batches, response.search_total_results_count, offset));
        })
        .catch(error => {
          dispatch(showFailure(error));
        }),
    });
  };
}

export function getBatchStats() {
  return dispatch => {
    const url = makeUrl('/batch_stats');
    return dispatch({
      type: types.FETCH_BATCH_STATS,
      payload: apiGet(url)
        .then(response => dispatch(storeBatchStats(response.stats)))
        .catch(error => dispatch(showFailure(error))),
    });
  };
}

export function createBatch(data) {
  return dispatch => {
    dispatch({ type: types.CREATE_BATCH });
    return apiPost(makeUrl('/batches'), data);
  };
}

export function updateBatch(batchId, data) {
  return dispatch => {
    dispatch({ type: types.UPDATE_BATCH });
    return apiPut(makeUrl(`/batches/${batchId}`), data)
      .done(res => {
        dispatch(showSuccess('landlordPortal.batches.successHeader'));
      })
      .catch(err => {
        console.error(err);
        dispatch(showFailure('landlordPortal.batches.errorHeader'));
      });
  };
}

export function deleteBatch(batchId) {
  return dispatch => {
    dispatch({ type: types.DELETE_BATCH });
    return apiDelete(makeUrl(`/batches/${batchId}`))
      .done(res => {
        dispatch(showSuccess('landlordPortal.batches.deleteBatchSuccess'));
      })
      .catch(err => {
        console.error(err);
        dispatch(showFailure('landlordPortal.batches.deleteBatchError'));
      });
  };
}

export function scheduleBatch(batchId, data) {
  data['post_at'] = toFriendlyDateString(data['post_at']);
  return dispatch => {
    dispatch({ type: types.SCHEDULE_BATCH });
    return apiPut(makeUrl(`/batches/${batchId}/schedule`), data);
  };
}

export function unscheduleBatch(batchId) {
  return dispatch => {
    dispatch({ type: types.UNSCHEDULE_BATCH });
    return apiPut(makeUrl(`/batches/${batchId}/unschedule`));
  };
}

export function getFilteredBatchPayments(batchId, subset = 'all', offset = 0, options = {}) {
  return dispatch => {
    return dispatch({
      type: types.FETCH_BATCH_PAYMENTS,
      payload: apiPost(
        makeUrl(`/batches/${batchId}/filtered_batch_payments?subset=${subset}&offset=${offset}`),
        options
      )
        .done(response => {
          dispatch(
            storeBatchPayments(response.batch_payments, response.search_total_results_count, offset)
          );
        })
        .catch(error => {
          dispatch(showFailure(error));
        }),
    });
  };
}

export function createBatchPayment(data) {
  return dispatch => {
    dispatch({ type: types.CREATE_BATCH_PAYMENT });
    return apiPost(makeUrl(`/batches/${data.batch_id}/payments`), data);
  };
}

export function deleteBatchPayment(data) {
  const { batchId, batchPaymentId } = data;
  return dispatch => {
    dispatch({ type: types.DELETE_BATCH_PAYMENT });
    return apiDelete(makeUrl(`/batches/${batchId}/batch_payments/${batchPaymentId}`));
  };
}

export function updateBatchPayment(batchId, batchPaymentId, data) {
  return dispatch => {
    dispatch({ type: types.UPDATE_BATCH_PAYMENT });
    return apiPut(makeUrl(`/batches/${batchId}/batch_payments/${batchPaymentId}`), data);
  };
}

export const clearBatchPayments = () => storeBatchPayments([], 0, 0);
